import { createEvent } from 'effector';

const logout = createEvent<'recovery' | 'invite' | void>();

const $$logoutUser = {
  logout
};

export { $$logoutUser };
